import { useState } from 'react';
import '../Styles/hrcom.css';
import JoinModal from '../components/JoinModel';

function HrCom() {
  const [isJoinOpen, setIsJoinOpen] = useState(false);

  return (
    <>
      {/* ===================================================
          SECTION 1: HERO — HR COMMUNITY NETWORK
      =================================================== */}
      <section className="hrcom-hero">
        {/* Single full-screen background image (no slideshow) */}
        <div className="hrcom-hero-bg">
          <img
            src="/assets/com_bg_img.png"
            alt="Vanakkam HRD community"
            className="hrcom-hero-bg-img"
          />
        </div>

        {/* Dark left-to-right shade for text readability */}
        <div className="hrcom-hero-overlay"></div>

        {/* Actual content, sits above the background */}
        <div className="hrcom-hero-content">
        <div className="hrcom-hero-left">
            <h1 className="hrcom-hero-title">HR Community Network</h1>

            <p className="hrcom-hero-subtitle">
              Vanakkam HRD Community Network connects HR professionals, CHROs, business leaders, academicians, and emerging talent on one collaborative platform. Through networking events, leadership forums, conferences, and knowledge-sharing initiatives, we foster meaningful connections, professional growth, and business opportunities that shape the future of work.
            </p>

            <button
              type="button"
              className="hrcom-hero-btn"
              onClick={() => setIsJoinOpen(true)}
            >
            Become a Member
            <img
                src="/assets/About_arrow_icon.png"
                alt="Arrow Icon"
                className="hrcom-arrow-icon"
            />
            </button>
        </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 2: OUR SERVICES
      =================================================== */}
      <section className="hrcom-services-section">
        <div className="hrcom-services-container">
          <h2 className="hrcom-services-heading">Our Services</h2>
          <p className="hrcom-services-subtitle">
            Empowering HR professionals and organizations through networking, leadership, learning, and collaboration.
          </p>

          <div className="hrcom-services-row">
            <div className="hrcom-service-card">
              <div className="hrcom-service-icon">
  <img
    src="/assets/HRcom_icon_1.png"
    alt="HRcom Icon 1"
    className="hrcom-service-icon-img"
  />
</div>
              <h3 className="hrcom-service-card-title">
                HR Networking &amp; Community Engagement
              </h3>
              <p className="hrcom-service-card-desc">
                Expand your professional network by connecting with HR leaders, industry experts, and business decision-makers through exclusive networking events, community meetups, and leadership forums.
              </p>
            </div>

            <div className="hrcom-service-card">
              <div className="hrcom-service-icon">
  <img
    src="/assets/HRcom_icon_2.png"
    alt="HRcom Icon 2"
    className="hrcom-service-icon-img"
  />
</div>
              <h3 className="hrcom-service-card-title">
                Leadership Events &amp; Conferences
              </h3>
              <p className="hrcom-service-card-desc">
                Participate in premium HR conferences, leadership summits, panel discussions, webinars, roundtables, and knowledge-sharing sessions featuring renowned industry experts.
              </p>
            </div>

            <div className="hrcom-service-card">
              <div className="hrcom-service-icon">
                <img
                  src="/assets/HRcom_icon_3.png"
                  alt="HRcom Icon 3"
                  className="hrcom-service-icon-img"
                />
              </div>
              <h3 className="hrcom-service-card-title">
                Employer Branding &amp; Business Visibility
              </h3>
              <p className="hrcom-service-card-desc">
                Enhance your organization's presence through sponsorships, speaking opportunities, exhibition spaces, digital promotions, and strategic branding initiatives that reach thousands of HR professionals.
              </p>
            </div>

            <div className="hrcom-service-card">
              <div className="hrcom-service-icon">
                <img
                  src="/assets/HRcom_icon_4.png"
                  alt="HRcom Icon 4"
                  className="hrcom-service-icon-img"
                />
              </div>
              <h3 className="hrcom-service-card-title">
                Learning &amp; Professional Development
              </h3>
              <p className="hrcom-service-card-desc">
                Stay ahead of industry trends with workshops, masterclasses, certification programs, leadership development initiatives, and continuous learning opportunities designed for modern HR professionals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 3: WHY CHOOSE VANAKKAM HRD AS YOUR PARTNER
      =================================================== */}
      <section className="hrcom-partner-section">
        <div className="hrcom-partner-container">
          <h2 className="hrcom-partner-heading">
            Why Choose Vanakkam HRD as Your Partner?
          </h2>
          <div className="hrcom-partner-underline"></div>

          <div className="hrcom-partner-content">
            {/* LEFT — numbered list */}
            <div className="hrcom-partner-left">
              <div className="hrcom-partner-item">
                <span className="hrcom-partner-number">01</span>
                <div className="hrcom-partner-text">
                  <h3 className="hrcom-partner-item-title">
                    Strong HR Community
                  </h3>
                  <p className="hrcom-partner-item-desc">
                    Become part of one of India's growing HR communities, connecting professionals, organizations, and industry leaders.
                  </p>
                </div>
              </div>

              <div className="hrcom-partner-item">
                <span className="hrcom-partner-number">02</span>
                <div className="hrcom-partner-text">
                  <h3 className="hrcom-partner-item-title">
                    Meaningful Networking
                  </h3>
                  <p className="hrcom-partner-item-desc">
                   Build valuable relationships with CHROs, HR Heads, CXOs, business leaders, and emerging professionals through curated networking experiences.
                  </p>
                </div>
              </div>

              <div className="hrcom-partner-item">
                <span className="hrcom-partner-number">03</span>
                <div className="hrcom-partner-text">
                  <h3 className="hrcom-partner-item-title">
                    Thought Leadership
                  </h3>
                  <p className="hrcom-partner-item-desc">
                    Showcase your expertise through speaking opportunities, panel discussions, webinars, articles, and leadership forums.
                  </p>
                </div>
              </div>

              <div className="hrcom-partner-item">
                <span className="hrcom-partner-number">04</span>
                <div className="hrcom-partner-text">
                  <h3 className="hrcom-partner-item-title">
                    Brand Growth &amp; Visibility
                  </h3>
                  <p className="hrcom-partner-item-desc">
                    Increase your brand presence through high-impact events, digital campaigns, sponsorship opportunities, and community engagement.
                  </p>
                </div>
              </div>

              <div className="hrcom-partner-item">
                <span className="hrcom-partner-number">05</span>
                <div className="hrcom-partner-text">
                  <h3 className="hrcom-partner-item-title">
                    Strategic Partnerships
                  </h3>
                  <p className="hrcom-partner-item-desc">
                    Collaborate with leading organizations, educational institutions, technology providers, and industry experts to drive mutual growth.
                  </p>
                </div>
              </div>

              <div className="hrcom-partner-item">
                <span className="hrcom-partner-number">06</span>
                <div className="hrcom-partner-text">
                  <h3 className="hrcom-partner-item-title">
                    Trusted Community Platform
                  </h3>
                  <p className="hrcom-partner-item-desc">
                    Vanakkam HRD is committed to creating meaningful experiences that inspire collaboration, celebrate excellence, and contribute to the growth of the HR profession.
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT — image */}
            <div className="hrcom-partner-right">
              <div className="hrcom-partner-img-wrap">
                <img
                  src="/assets/HRcom_image_2.png"
                  alt="Vanakkam HRD background accent"
                  className="hrcom-partner-img-accent"
                />
                <img
                  src="/assets/HRcom_image_1.png"
                  alt="Vanakkam HRD professionals in discussion"
                  className="hrcom-partner-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <JoinModal isOpen={isJoinOpen} onClose={() => setIsJoinOpen(false)} />
    </>
  );
}

export default HrCom;
